module.exports = __webpack_public_path__ + "static/media/loader.7dc666d7.gif";